import { render } from "./textEditor.vue?vue&type=template&id=6a5e837e&scoped=true"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"

import "./textEditor.vue?vue&type=style&index=0&id=6a5e837e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5e837e"]])

export default __exports__